import { Badge } from '@/components/ui'
import type { FranchiseTeacherStatus, TeacherAttestationResult, TeacherTrainingStatus } from '@/services/franchiseTeacherService'

export const teacherStatusLabels: Record<FranchiseTeacherStatus, string> = {
  candidate: 'Кандидат',
  training: 'В обучении',
  working: 'Работает',
  dismissed: 'Уволен',
}

export function teacherStatusLabel(status: string | null | undefined): string {
  if (status && status in teacherStatusLabels) {
    return teacherStatusLabels[status as FranchiseTeacherStatus]
  }
  return status || 'Статус не указан'
}

export const trainingStatusLabels: Record<TeacherTrainingStatus, string> = {
  in_progress: 'В процессе',
  completed: 'Завершено',
  closed: 'Закрыто',
}

export const attestationResultLabels: Record<TeacherAttestationResult, string> = {
  passed: 'Сдал',
  retake: 'Пересдача',
  refused: 'Отказ',
}

export function TeacherStatusBadge({ status }: { status: FranchiseTeacherStatus }) {
  const variant = status === 'working'
    ? 'success'
    : status === 'training'
      ? 'warning'
      : status === 'dismissed'
        ? 'error'
        : 'neutral'

  return <Badge variant={variant}>{teacherStatusLabels[status]}</Badge>
}

export function TrainingStatusBadge({ status }: { status: TeacherTrainingStatus }) {
  const variant = status === 'completed'
    ? 'success'
    : status === 'closed'
      ? 'error'
      : 'warning'

  return <Badge variant={variant}>{trainingStatusLabels[status]}</Badge>
}

export function AttestationResultBadge({ result }: { result: TeacherAttestationResult | null }) {
  if (!result) return <Badge variant="neutral">Ожидается</Badge>
  const variant = result === 'passed' ? 'success' : result === 'refused' ? 'error' : 'warning'
  return <Badge variant={variant}>{attestationResultLabels[result]}</Badge>
}
